import type { TWellListView, TWellsFilterView } from 'src/api-types/wells.types';

import { WorkspaceApi } from '../api/TabsApi';

export class PreloadWidgetService {
  private readonly api = new WorkspaceApi();

  private collection: Map<string, object> & {
    get<T>(type: string): T;
    set<T>(type: string, data: T): void;
  } = new Map();

  async preload(): Promise<void> {
    try {
      const [wellListView, wellsFilterView] = await Promise.all([
        this.api.fetchWellListView(),
        this.api.fetchWellsFilterView(),
      ]);

      this.collection.set<TWellListView>('well-list-control', wellListView);
      this.collection.set<TWellsFilterView>('filter-control', wellsFilterView);
    } catch (error) {
      console.error(error);
    }
  }

  getPreloadedData<T>(type: string): T {
    if (!this.collection.has(type)) {
      console.error(`${type} - data not found`);
      throw new Error('data not found');
    }

    return this.collection.get<T>(type);
  }
}
